import { useEffect, useState } from "react";
import { TodaysTireBalancingService } from "./TodaysTireBalancingService";
import { TodaysTireChangeService } from "./TodaysTireChangeService"
import { TodaysTireRotationService } from "./TodaysTireRotationService";
import { TodaysWheelChangeService } from "./TodaysWheelChangeService";
import { getCustomerServices } from "../../../services/Services";

type DailyManifestProps = {
    date: string;
    locationId: number
}

export const DailyManifest = ({ date, locationId }: DailyManifestProps) => {
    const [allServiceType, setAllServiceType] = useState<any[]>([]);

    useEffect(() => {
        getCustomerServices()
            .then((data) => {
                const serviceData = data.reverse()?.slice(0, 5)?.map((option: any) => {
                    return {
                        id: option?.serviceID
                    }
                })
                setAllServiceType(serviceData)

            }).catch((error) => {
                setAllServiceType([]);
                console.error(error);
            })
    }, [])


    return (
        <>
            <div className="w-full mt-4">

                <TodaysTireChangeService date={date} locationId={locationId} serviceId={allServiceType[0]?.id} />
            </div>

            <div className="w-full mt-4">
                <TodaysWheelChangeService date={date} locationId={locationId} serviceId={allServiceType[1]?.id} />
            </div>

            <div className="w-full mt-4">
                <TodaysTireBalancingService date={date} locationId={locationId} serviceId={allServiceType[2]?.id} />
            </div>

            <div className="w-full mt-4">
                <TodaysTireRotationService date={date} locationId={locationId} serviceId={allServiceType[3]?.id} />
            </div>
        </>
    )
}